export default __webpack_public_path__ + "static/media/Apple iPhone 7 Plus.e59b7a43.png";